import axios from "axios";

async function issueStateUpdateRequest(
  panelComponent,
  route,
  data = null,
  method = "get"
) {
  panelComponent.setState({ loading: true });

  let rootUrl = "http://localhost:8082";
  if (window.location.hostname !== "localhost") {
    rootUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      window.location.port +
      "/api";
  }

  try {
    const resp = await axios({
      method: method,
      url: rootUrl.concat(route),
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      data: data,
    });
    if ("state" in resp.data) {
      panelComponent.setState(resp.data.state);
      console.log("Axios state loaded:", resp.data);
    }
    if ("_error" in resp.data) {
      console.error(Date(), resp.data);
      panelComponent.setState({
        dynamicSnackbar: {
          ...panelComponent.state.dynamicSnackbar,
          severity: "error",
        },
      });
      panelComponent.setState({
        dynamicSnackbar: {
          ...panelComponent.state.dynamicSnackbar,
          open: true,
        },
      });
    }
    if ("_notification" in resp.data) {
      var severity = "success";
      if ("severity" in resp.data._notification) {
        severity = resp.data._notification.severity;
      }
      if ("url" in resp.data._notification) {
        panelComponent.setState({
          dynamicSnackbar: {
            ...panelComponent.state.dynamicSnackbar,
            url: resp.data._notification.url,
          },
        });
      }

      panelComponent.setState({
        dynamicSnackbar: {
          ...panelComponent.state.dynamicSnackbar,
          severity: severity,
        },
      });
      panelComponent.setState({
        dynamicSnackbar: {
          ...panelComponent.state.dynamicSnackbar,
          message: resp.data._notification.text,
        },
      });
      panelComponent.setState({
        dynamicSnackbar: {
          ...panelComponent.state.dynamicSnackbar,
          open: true,
        },
      });
    }

    panelComponent.setState({ loading: false });
    return resp.data;
  } catch (err) {
    console.error(Date(), err);
    panelComponent.setState({
      dynamicSnackbar: {
        ...panelComponent.state.dynamicSnackbar,
        severity: "error",
      },
    });
    panelComponent.setState({
      dynamicSnackbar: { ...panelComponent.state.dynamicSnackbar, open: true },
    });
    panelComponent.setState({ loading: false });
  }
}

export default issueStateUpdateRequest;
